let fetchInner;
try {
    fetchInner = window.fetch.bind(window);
}
catch (e) {
    fetchInner = window.fetch;
}
export const fetch = fetchInner;
